import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import authReducer from './AuthSlice';
import powerBiReducer from './PowerBiSlice';
import chatBotReducer from './ChatBotSlice';
import chatSliceReducer from './ChatBotGenieSlice';
import supervisorChatReducer from './SupervisorChatSlice';
import npsSubmissionReducer from './NpsSlice';
import {chatUISlice} from './ChatUIDashboardSlice';
import {powerBiApi} from './PowerbiSliceRedux';
import {homeCatalogApi} from './HomeCatalogApi';
import {setupListeners} from '@reduxjs/toolkit/query';

import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [powerBiApi.reducerPath, homeCatalogApi.reducerPath],
};

const rootReducer = combineReducers({
  oktaAuth: authReducer,
  powerBiSlice: powerBiReducer,
  chatSlice: chatBotReducer,
  chatSliceGenie: chatSliceReducer,
  supervisorChatSlice: supervisorChatReducer,
  npsSlice: npsSubmissionReducer,
  chatUI: chatUISlice.reducer,
  [powerBiApi.reducerPath]: powerBiApi.reducer,
  [homeCatalogApi.reducerPath]: homeCatalogApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(powerBiApi.middleware, homeCatalogApi.middleware),
});
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const persistor = persistStore(store);
